import React, { Component } from 'react';

import clsx from 'clsx';
import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink as Link } from 'react-router-hash-link';
import { Spring } from 'react-spring';

import SearchInput from 'components/SearchModal/SearchInput';
import { BrandLogoCarousel } from 'components/BrandLogoCarousel/BrandLogoCarousel';
import { GlassWidgetPanel } from 'components/GlassCards/GlassWidgetPanel';
import { SmartAssist } from 'components/SmartAssist/SmartAssist';

import { storageKeys, bgVideo } from 'settings';
import { useSettings } from 'hooks/useSettings';

import BackVideo from 'components/BackVideo';
import NotificationSlider from 'components/NotificationSlider';
import SweetAlert from 'components/SweetAlert';
import WelcomeVideo from 'components/WelcomeVideo';
import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';
import StorageHandler from 'config/StorageHandler';
import getFeatureFlags from 'helpers/getFeatureFlags';
import { UNSAFE_malformAppInfo } from 'config/AppSettings/AppSettings';
import { isRewardsCountry } from 'helpers/isRewardsCountry';

class HomeViewInner extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: '',
      appId: -1,
      userStatus: 'startTraining',
      firstName: '',
      destination: null,
      noAgent: false,
      germanVersion: false,
      logo: null,
      leftGraphic: null,
      centerGraphic: null,
      bottomGraphic: null,
      homeSliderImages: [],
      whiteLogo: null,
      popup: false,
      landingQuote: null,
      landingQuoteImageExists: true,
      introVideo: null,
      showWelcomeVideo: false,
      lastName: null,
      email: null,
      langCode: 'en-US',
      userCountry: '',
      isRewardsCountryEligible: false,
      featureFlags: {
        rewards: false,
        ambassador: false,
        showcases: false,
        enable_destination_showcases_label: false,
        smart_assist: false,
        directory: false,
        white_home_logo: false,
        wide_home_logo: false,
        enable_advisor_dashboard: false,
        enable_advisor_dashboard_light_theme: false,
        enable_advisor_dashboard_right: false,
      },
    };

    this.close = this.close.bind(this);
    this.getToken = this.getToken.bind(this);
  }

  UNSAFE_componentWillMount() {
    document.body.classList.add('no-scroll');

    StorageHandler.load(storageKeys.user).then((res) => {
      const userCountry = res?.country ?? '';
      const firstName = res?.first_name ?? '';
      isRewardsCountry(userCountry).then((isRewardsCountryEligible) => {
        this.setState({ isRewardsCountryEligible });
      });
      if (res.training_graduated) {
        return this.setState({ userStatus: 'graduated', userCountry, firstName });
      }
      if (res.training_started) {
        return this.setState({ userStatus: 'continueTraining', userCountry, firstName });
      }
      return this.setState({ userStatus: 'startTraining', userCountry, firstName });
    });
  }

  componentDidMount() {
    const d = new Date(Date.now());
    const leading = (val) => {
      return `0${val}`.slice(-2);
    };

    StorageHandler.load(storageKeys.user).then((user) => {
      const firstname = user?.first_name;
      const lastName = user?.last_name;
      const email = user?.email;
      if (firstname) {
        this.setState({ firstName: firstname, lastName: lastName, email: email });
      }
    });

    DataHandler.matchAppId().then((appId) => {
      this.setState({ appId });
      StorageHandler.load(storageKeys.user).then((user) => {
        if (user && user.sales_companion_registered === null) {
          const obj = user;
          const date = `${d.getFullYear()}-${leading(d.getMonth() + 1)}-${leading(d.getDate())}`;

          APIHandler.updateUser(appId, obj.email, [{ param: 'sales_companion_registered', val: date }]).then((res) => {
            if (res) {
              obj.sales_companion_registered = date;
              StorageHandler.save(storageKeys.user, obj);
            }
          });
        }
      });
    });

    this.getAppInfo();
  }

  componentWillUnmount() {
    document.body.classList.remove('no-scroll');
  }

  setQuery() {
    const { query } = this.state;
    if (query.length > 0) {
      StorageHandler.save(storageKeys.lastSearchQuery, query);
    }
  }

  async getAppInfo() {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);

    if (appInfo) {
      const introVideo = appInfo.introVideo;
      const appId = appInfo.appId;

      const { code: langCode } = (await StorageHandler.load(storageKeys.lang)) ?? {};

      this.setState({
        landingQuote: appInfo.landingQuote,
        logo: appInfo.logo,
        whiteLogo: appInfo.logoWhite,
        logoWide: appInfo.logoWide,
        logoWideWhite: appInfo.logoWideWhite,
        leftGraphic: appInfo.leftGraphic,
        centerGraphic: appInfo.centerGraphic,
        bottomGraphic: appInfo.bottomGraphic,
        homeSliderImages: appInfo.homeSliderImages ?? [],
        introVideo: appInfo.introVideo,
        destination: appInfo.destination,
        langCode: langCode ?? 'en-US',
      });

      const key = `hasSeenWelcomeVideo_${appId}`;
      const hasSeen = await StorageHandler.load(key);

      if (introVideo && !hasSeen) {
        this.setState({ showWelcomeVideo: true });
        StorageHandler.save(key, true, null);
      }

      const flags = await getFeatureFlags();
      this.setState((prevState) => {
        return {
          featureFlags: { ...prevState.featureFlags, ...flags },
        };
      });
    } else {
      const newAppInfo = await APIHandler.getAppInfo(import.meta.env.VITE_APP_ID);
      const { code } = await StorageHandler.load(storageKeys.lang);

      if (newAppInfo?.app?.[0]) {
        StorageHandler.save(
          storageKeys.appInfo,
          UNSAFE_malformAppInfo(newAppInfo, code ?? '', import.meta.env.VITE_APP_ID),
        );
        this.getAppInfo();
      }
    }
  }

  async getToken() {
    return StorageHandler.load(storageKeys.accessToken);
  }

  close() {
    this.setState({
      popup: false,
    });
  }

  openPopup() {
    this.setState({
      openMessage: true,
    });
  }

  render() {
    const { salesCompanionAppId } = this.props;
    const {
      appId,
      langCode,
      popup,
      userStatus,
      firstName,
      destination,
      landingQuote,
      featureFlags,
      logo,
      whiteLogo,
      logoWide,
      logoWideWhite,
      leftGraphic,
      centerGraphic,
      bottomGraphic,
      homeSliderImages,
      landingQuoteImageExists,
      introVideo,
      showWelcomeVideo,
      isRewardsCountryEligible,
    } = this.state;
    const rewardsLocked = isRewardsCountryEligible && userStatus !== 'graduated';
    const smartAssistEnabled = featureFlags.smart_assist === true;

    const showRewardsLockedPopup = () => {
      this.setState({
        popup: true,
      });
    };

    const handleRewardsClick = (e) => {
      if (rewardsLocked) {
        e.preventDefault();
        showRewardsLockedPopup();
      }
    };

    // Both wide and white home logo flags can be used together. Logo's can be either rgb or white, and both can be wide or not.
    const getActiveLogo = () => {
      if (featureFlags.wide_home_logo) {
        if (featureFlags.white_home_logo) {
          return logoWideWhite;
        }

        return logoWide;
      }

      if (featureFlags.white_home_logo) {
        return whiteLogo;
      }

      return logo;
    };

    const activeLogo = getActiveLogo();
    const logoFallbackUrl = `https://front.travpromobile.com/${import.meta.env.VITE_APP_ID}/logo.png`;
    // const logoFallbackUrl = 'https://front.travpromobile.com/1839/landingQuote.png';
    // console.log('logoFallbackUrl', logoFallbackUrl);

    const widgetAppId = salesCompanionAppId || appId;

    const dashboardOn = featureFlags.enable_advisor_dashboard === true;
    const useRight = dashboardOn && featureFlags.enable_advisor_dashboard_right === true;

    return (
      <div className="homeContainer">
        {bgVideo && <BackVideo darken />}
        <div className="bgHome" />

        <div className="bgDecorationHome__item--1" />

        {leftGraphic && (
          <div className="bgDecorationHome__leftGraphic" style={{ backgroundImage: `url(${leftGraphic})` }} />
        )}

        {centerGraphic && (
          <div className="bgDecorationHome__centerGraphic" style={{ backgroundImage: `url(${centerGraphic})` }} />
        )}

        {bottomGraphic && (
          <div className="bgDecorationHome__bottomGraphic" style={{ backgroundImage: `url(${bottomGraphic})` }} />
        )}

        <img src={activeLogo || logoFallbackUrl} className="homeLogoTop" alt="logo" />

        <Spring from={{ transform: 'translateY(30%)', opacity: 0 }} to={{ transform: 'translateY(0%)', opacity: 1 }}>
          {(props) => {
            return (
              <div data-testid="home-view" className="homeView" style={props}>
                <div className="homeView__title">
                  {homeSliderImages.length > 0 && (
                    <div className="homeView__brandCarousel">
                      <BrandLogoCarousel logos={homeSliderImages} className="homeView__brandCarousel--track" />
                    </div>
                  )}
                  <img src={activeLogo || logoFallbackUrl} className="homeLogo" alt="central logo" />
                  {landingQuote && <h1 className="subtitle">{landingQuote}</h1>}
                  {!landingQuote && landingQuoteImageExists && (
                    <img
                      src={`https://front.travpromobile.com/${import.meta.env.VITE_APP_ID}/landingQuote.png`}
                      alt="Landing quote"
                      className="landingQuoteImage"
                      onError={() => {
                        return this.setState({ landingQuoteImageExists: false });
                      }}
                    />
                  )}
                  <div className="homeView__title--line" />
                  <div className="homeView__title--action">
                    {!smartAssistEnabled && <SearchInput />}
                    {!smartAssistEnabled && (
                      <div className="homepage__buttons" data-testid="home-page-buttons">
                        {featureFlags.showcases && (
                          <Link
                            to="/main/showcases"
                            className={clsx('showcaseBtn', 'titleButton', {
                              'titleButton--tall': featureFlags.enable_destination_showcases_label,
                            })}
                          >
                            <div>
                              <FontAwesomeIcon className="titleButton__icon" icon={['fas', 'star']} />
                              <p className="titleButton__label">
                                {featureFlags.enable_destination_showcases_label
                                  ? i18n.translate('nav.destinationShowcases')
                                  : i18n.translate('nav.showcases')}
                              </p>
                            </div>
                          </Link>
                        )}
                        {featureFlags.directory && !featureFlags.button_bar_directory && (
                          <Link to="/main/directory" className="directoryBtn">
                            <div className="directoryBtn__label">
                              <FontAwesomeIcon icon={['fas', 'list']} />
                              <p>{i18n.translate('nav.directory')}</p>
                            </div>
                          </Link>
                        )}
                        {featureFlags.rewards && isRewardsCountryEligible && (
                          <Link
                            to="/main/rewards"
                            className={clsx('rewardsBtn', 'titleButton', {
                              'titleButton--tall': featureFlags.enable_destination_showcases_label,
                            })}
                            onClick={handleRewardsClick}
                          >
                            <div>
                              {rewardsLocked ? (
                                <FontAwesomeIcon className="titleButton__icon" icon={['fas', 'lock']} />
                              ) : (
                                <FontAwesomeIcon
                                  className="titleButton__icon"
                                  icon={['fas', featureFlags.ambassador ? 'trophy-star' : 'treasure-chest']}
                                />
                              )}
                              <p className="titleButton__label">
                                {i18n.translate(featureFlags.ambassador ? 'nav.achievements' : 'nav.rewards')}
                              </p>
                            </div>
                          </Link>
                        )}
                      </div>
                    )}
                    {smartAssistEnabled && (
                      <SmartAssist
                        appId={appId}
                        firstName={firstName}
                        destination={destination}
                        getToken={this.getToken}
                      />
                    )}
                  </div>
                </div>
              </div>
            );
          }}
        </Spring>

        {dashboardOn && (
          <GlassWidgetPanel
            appId={widgetAppId}
            dashboardAppId={appId}
            dashboardLangCode={langCode}
            rewards={featureFlags.rewards && isRewardsCountryEligible && !rewardsLocked}
            metallicTiers={featureFlags.metallic_tiers === true}
            lightTheme={featureFlags.enable_advisor_dashboard_light_theme === true}
            position={useRight ? 'right' : 'left'}
            firstName={this.state.firstName}
            lastName={this.state.lastName}
            email={this.state.email}
          />
        )}

        <div className="homeContainer__topLine" />
        <div className="bottomLine" />
        {!dashboardOn && <NotificationSlider appId={widgetAppId} middle right />}
        <SweetAlert
          title=""
          trigger={popup}
          html={i18n.translate('rewards.lockedPopupNotGraduated')}
          confirmButtonText={i18n.translate('general.close')}
          onClose={this.close}
        />
        <SweetAlert
          title=""
          trigger={showWelcomeVideo}
          html={
            <WelcomeVideo
              src={introVideo}
              poster={`https://front.travpromobile.com/${appId}/welcome+video+poster.png`}
            />
          }
          showConfirmButton={false}
          cancelButtonText={i18n.translate('general.close')}
          showCancelButton
          customClass="homePopup"
          onCancel={() => {
            return this.setState({ showWelcomeVideo: false });
          }}
          onClose={() => {
            return this.setState({ showWelcomeVideo: false });
          }}
        />
      </div>
    );
  }
}

export default function HomeView(props) {
  const { salesCompanionAppId } = useSettings();
  return <HomeViewInner {...props} salesCompanionAppId={salesCompanionAppId} />;
}
